import { FC } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { Modal } from '@mui/material';
import { CloseIcon /* HideOrShowAccountModalIcon */ } from 'assets';
import { TUpdate } from 'domain/types';
import { Button } from 'view/components';
import * as CS from 'view/modals/styled';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { useUpdateJobPostStatus } from 'view/pages/candidates/hooks/useUpdateJobPostStatus';

const MoveJobPostToActiveModal: FC<{ hideCloseButton?: boolean; successFunction: any }> = ({
  hideCloseButton = false,
  successFunction,
}) => {
  const isOpenMoveJobPostToActiveModal: boolean = useCS(
    GlobalConfigContext,
    globalConfigSelectors.isOpenMoveJobPostToActiveModal
  );

  const jobPostIdToActive: number | null = useCS(
    GlobalConfigContext,
    globalConfigSelectors.jobPostIdToActive
  );

  const update: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { isLoading, updateJobPostStatus } = useUpdateJobPostStatus();

  const onClose = () => {
    if (update) update({ isOpenMoveJobPostToActiveModal: false, jobPostIdToActive: null });
  };

  const onMoveToActiveClick = () => {
    updateJobPostStatus({ postStatus: 'active' }, jobPostIdToActive, successFunction);
  };

  return (
    <Modal
      open={isOpenMoveJobPostToActiveModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CS.ModalMainWrapper>
        {!hideCloseButton ? (
          <CS.CloseIconBox onClick={onClose}>
            <CloseIcon />
          </CS.CloseIconBox>
        ) : null}
        <CS.ModalMainBox>
          {/* <CS.ModalMainImage>
            <HideOrShowAccountModalIcon />
          </CS.ModalMainImage> */}
          <CS.ModalMainHeader>
            <CS.ModalMainHeaderTitle>Publish this job post?</CS.ModalMainHeaderTitle>
            <CS.ModalMainHeaderSubTitle>
              {
                'This job will be visible to job seekers once published. \n You can still edit or move it back to drafts at any time.'
              }
            </CS.ModalMainHeaderSubTitle>
          </CS.ModalMainHeader>
        </CS.ModalMainBox>
        <CS.ModalMainFooter>
          <Button
            variant="outlined"
            text="Publish"
            onClick={onMoveToActiveClick}
            disabled={isLoading}
            style={{ width: '100%', minHeight: '50px' }}
          />
          <Button variant="contained" text="Cancel" onClick={onClose} />
        </CS.ModalMainFooter>
      </CS.ModalMainWrapper>
    </Modal>
  );
};

export default MoveJobPostToActiveModal;
